// extracted by mini-css-extract-plugin
export default {"nodataGraphIcon":"Ifb7WVV4FPArXPP8nlDE","nodataGraphSkeleton":"NpLsuZftG28a5MYRWSZ3"};